module.exports = __webpack_public_path__ + "img/business-solutions-secondary-hero-mobile@2x.560edace.webp";